import { apiClientMutator } from '~/infrastructure/config/mutator';
import { Country } from '~/Api/Country';
import { ProductUpdate } from '~/libs/infrastructure/schemas/czMaxPrice';
import { mapCzMaxPrice } from '~/libs/infrastructure/mappers/czMaxPrice';
import ReferenceBasketVersion from '~/Api/PriceReferencing/ReferenceBasketVersion';
import {
	CzechMaxPricePriceReferenceBasketVersionResponse,
	CzechMaxPricePriceReferencingReferenceBasketVersionsResponse,
	CzechMaxPriceWrappedCalculationSettingsResponse,
	WrappedExportResponse,
} from 'com.cogvio.pricemonitor.api';

export function getCzMaxPrice(userId: string, groupId: string) {
	return apiClientMutator<CzechMaxPriceWrappedCalculationSettingsResponse>({
		url: `/users/${userId}/product-groups/${groupId}/cz-max-price`,
		method: 'get',
	}).then((data) => mapCzMaxPrice(data.czMaxPrice));
}

export function postCzMaxPriceUpdate(
	userId: string,
	groupId: string,
	packageSize: number | null,
	referenceBasketVersion: string,
	products: ProductUpdate[]
) {
	return apiClientMutator<CzechMaxPriceWrappedCalculationSettingsResponse>({
		url: `/users/${userId}/product-groups/${groupId}/cz-max-price`,
		method: 'post',
		data: JSON.stringify({
			reference: { packageSize, referenceBasketVersion },
			products: products.map((product) => ({
				id: product.id,
				priceTypeForCalculation: product.priceTypeForCalculation,
				packageSizeForCalculation: product.packageSizeForCalculation,
				packageSizeForSingleUnit: product.packageSizeForSingleUnit,
				selected: product.selected,
			})),
		}),
	}).then((data) => mapCzMaxPrice(data.czMaxPrice));
}

export function postCzMaxPriceExportXls(userId: string, groupId: string) {
	return apiClientMutator<WrappedExportResponse>({
		url: `/users/${userId}/product-groups/${groupId}/cz-max-price/export-xls`,
		method: 'post',
	});
}

function mapReferenceBasketVersion(version: CzechMaxPricePriceReferenceBasketVersionResponse): ReferenceBasketVersion {
	return new ReferenceBasketVersion(
		version.id,
		version.description,
		new Date(version.sinceDate),
		version.referenceCountries.map((c) => new Country(c.alpha2, c.name))
	);
}

export function getCzMaxPriceReferenceBasketVersions() {
	return apiClientMutator<CzechMaxPricePriceReferencingReferenceBasketVersionsResponse>({
		url: '/cz-price-referencing/max-price/reference-basket-versions',
		method: 'get',
	}).then((data) => data.items.map(mapReferenceBasketVersion));
}
